import { clsx } from 'clsx';

import styles from './SignupLayoutHeadingDirectUK.module.css';
import { useSplitTestContext } from '../../../hooks/useSplitTestContext';
import BackToStep from '../../BackToStep/BackToStep';
import MyAccount from '../../MyAccount/MyAccount';

type TSignupLayoutHeadingDirectUK = {
  currentStep: string;
};

const SignupLayoutHeadingDirectUK = ({
  currentStep,
}: TSignupLayoutHeadingDirectUK) => {
  const { hasTradingHistoryRevampEnabled } = useSplitTestContext();

  if (currentStep === 'offers') return null;

  if (currentStep === 'documents' && hasTradingHistoryRevampEnabled)
    return null;

  return (
    <nav className={clsx(styles.navContainer, styles.directCustomerNav)}>
      {currentStep !== 'documents' && <BackToStep />}

      <MyAccount />
    </nav>
  );
};

export default SignupLayoutHeadingDirectUK;
